export const style = {
    mainWrapper: {marginTop: '25px', marginBottom: '25px'},
    ssidItem: {border: '1px solid rgba(100, 100, 115, 0.1)', padding: '8px'},
    copy: {marginLeft: '10px'},
    textSecurity: {padding: '8px'},
    spaceWithTop: {marginTop: '10px'},
    button: {
        borderRadius: '20px',
        backgroundColor: 'rgb(180, 199, 74)',
        color: 'white',
        border: 'rgb(180, 199, 74)',
    },
    secondButton: {
        marginTop: '8px',
        borderRadius: '20px',
        backgroundColor: 'rgb(180, 199, 74)',
        color: 'white',
        border: 'rgb(180, 199, 74)',
    },
    copyIcon: {marginRight: '10px'}
}
